export function safeParseJson<T> (raw: string | null, fallback: T): T {
  if (!raw) return fallback
  try {
    return JSON.parse(raw) as T
  } catch (_) {
    return fallback
  }
}

export function safeParseJsonAndClean<T> (storage: Storage, key: string, fallback: T): T {
  const raw = storage.getItem(key)
  if (!raw) return fallback
  try {
    return JSON.parse(raw) as T
  } catch (_) {
    // Corrupted value – remove to avoid repeated failures
    storage.removeItem(key)
    return fallback
  }
}
